import React, { useEffect, useState, useCallback } from "react";
import { useIntl } from "react-intl";
import { shallowEqual, useSelector } from "react-redux";
import { getCasesInDraft } from "./Utils/syncDataForOffline"
import { getEvents } from "./Utils/syncData";
import OfflineSyncDialog from "./OfflineSyncDialog";
import WarningSvg from "components/svg/Warning";
import useOfflineBar from "customHooks/useOfflineBar";

const OfflineBar = () => {
    const intl = useIntl();
    const {
        isAuthenticated,
        connection,
    } = useOfflineBar();

    const [showSyncBar, setShowSyncBar] = useState(false);
    const [showdialog, setShowDialog] = useState(false);
    const [casesLoading, setCasesLoading] = useState(false);

    const hasAgreedToSync = useSelector(state => state.saveComponentValue.hasAgreedToSync, shallowEqual);

    useEffect(() => {
        if (hasAgreedToSync) {
            syncNowHandler();
        }
    }, [hasAgreedToSync]);

    useEffect(() => {
        if (connection) {
            fetchData().catch(err => console.log(err));
        } else {
            setShowDialog(false);
        }
    }, [connection]);

    const fetchData = async () => { 
        const events = await getEvents();
        setShowSyncBar(events.length > 0);
    };

    const onCloseDialog = (hadItemsToSync) => { 
        setShowDialog(false);
        setShowSyncBar(hadItemsToSync);
    }

    const loadCasesInDraft = useCallback(async () => {
        setCasesLoading(true)
        await getCasesInDraft()
        setCasesLoading(false)
    }, [])

    const syncNowHandler = () => {
        try {
            loadCasesInDraft()
        } catch (e) {
            console.log(e)
        } finally {
            setShowDialog(true)
        }
    }
    
    const getSyncWarning = () => {
        return <>
            <WarningSvg color="#fff" className="message-bar__svg" />
            <span className="message-bar__svg">{intl.formatMessage({ id: "offline.dataToSync" })}</span>
            <button onClick={syncNowHandler} className="button button--background-green">
                <span className="button__text">{intl.formatMessage({ id: "offline.syncNow" })}</span>
            </button>
            <OfflineSyncDialog
                showdialog={showdialog}
                onCloseDialog={onCloseDialog}
                onSyncComplete={() => setShowSyncBar(false)}
                casesLoading={casesLoading}
            />
        </>;
    }

    const getOfflineWarning = () => { 
        return <>
            <WarningSvg className="message-bar__svg" />
            {intl.formatMessage({ id: "offlineMode" })}
        </>;
    }

    const isShowingSyncbar = connection && (showSyncBar || showdialog) && isAuthenticated;
    const barState = isShowingSyncbar ? 'success' : 'warning';

    return !connection || isShowingSyncbar ?
        <div className={`message-bar message-bar--${barState} message-bar--is-offline`}>
            <div className="message-bar__container">
                {isShowingSyncbar ? getSyncWarning() : getOfflineWarning()}
            </div>
        </div>
        : null
}

export default OfflineBar;